import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { FormControl, FormArray, FormGroup, AbstractControl } from '@angular/forms';
import { Event } from '@app/shared/_models/common';
import { Observable, throwError, merge, EMPTY } from 'rxjs';
import { map, distinct, mapTo, catchError, retry } from 'rxjs/operators';
import { LoginService } from '@app/common/login.service';
import * as constants from "@app/shared/constants";


import { TemplateAttribute, ProductAttribute, Product, ProductTpl,  Packaging, ProductPackagingVal } from '@app/shared/_models/product';

import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AttributesService {

  constructor( public loginService: LoginService, private http: HttpClient) { }

	// Get all attributes from product_attribute
  getAttributes(): Observable<ProductAttribute[]> {
    return this.http.get<ProductAttribute[]>(environment.server_url + "/product_attributes");
  }

	// Get tpl_attributes = template's attributes
	getTemplateAttributesAsFormArray(template: any): Observable<{f:FormArray, seq:number}> {
		let maxseq = 0;
		return this.getTemplateAttributes(template)
			.pipe(map((ta: TemplateAttribute[]) => {
				if (ta.length) console.log("last seq: " + ta[ta.length-1].seq);
				const fgs: FormArray = new FormArray(ta.map(TemplateAttribute.asFormGroup));
				return {f:fgs, seq:(ta.length==0?0:ta[ta.length-1].seq)};
		}))

	}
	
  getTemplateAttributes(template:any): Observable<any>{
    return this.http.get<void>(environment.server_url + "/template_attributes/" + template);
  }

/* UNUSED?
  getProduct_attribute_vals(attribute:any) {
    return this.http.get<void>(environment.server_url + "/product_attribute_vals/" + attribute);
  }
*/
  get_all_attributes_vals(): Observable<any> {
    return this.http.get<void>(environment.server_url + "/attribute_vals");
  }

	getProducts_attributes(typ: string, q: string): Observable<any> {
		return this.http.get<void>(environment.server_url + "/products?typ=" + typ + "&q=" + q);
	}

  postAttributeaction(attributes: any): Observable<any> {
    const headers = { 'content-type': 'application/json'};
    return this.http.post<any>(environment.server_url + "/product_attributes", attributes, {'headers':headers});
  }  
  
  // old not used before event re-writing (jpc) september 2025
	postTplattribute(ta:TemplateAttribute): Observable<any> {
		const headers = { 'content-type': 'application/json' };
		return this.http.post<any>(environment.server_url + "/tplattribute", ta, { 'headers': headers });
	}
  
  postTplattributeEvent(eventtyp: number, objectid: number, objecttyp: number, ta:TemplateAttribute ): Observable<any> {
    console.log('postTplattributeEvent');
    // let old_new = {'old':oldFormGroup.value, 'new':newFormGroup.value};
    let event:Event = {
      id: 0,
      typ: eventtyp,			// 1: Insert, 2: Update, 3: Delete and a lot more...  here  EventType.TPL_ATTRIBUTE_I  = 400;    // insert Template attribute
      userid: this.loginService.loggeduser?.id,			
      objectid: objectid,
      objecttyp: objecttyp,		//  Template 
      data: ta,
    }
    return this.http.post<any>(environment.server_url + "/event", event, { 'headers': constants.jsonheader });
  }


	
	postTplattributeaction(ta:any): Observable<any> {
		const headers = { 'content-type': 'application/json' };
		return this.http.post<any>(environment.server_url + "/tplattributeaction", ta, { 'headers': headers });
	}	
	
	deletetTplattribute(template:number, attribute: number): Observable<any> {
		return this.http.delete<any>(environment.server_url + "/tplattribute/"+ template + "/" + attribute);
	}		
}
